import * as React from 'react';
import { observable } from "mobx";
import { observer } from "mobx-react";
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ContextService } from 'src/core/services/context.service';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ProductProviderListView } from "./product-provider-list.view";
import { ProductProviderDataService } from "../product-provider.data";

@observer
export class ProductProviderListController extends React.Component<ControllerProps<any>, any> {
    @observable
	protected dataService: ProductProviderDataService;

	@resolve
	contextService: ContextService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

	public componentDidMount() {
		this.dataService = ProductProviderDataService.make(this.contextService);
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: ProductProviderItem) {
        this.props.history.push(`/products/product-providers/${item == null ? 'new' : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false)
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

	public render() {
		if (this.dataService == null) {
			return null;
		}

		return <ProductProviderListView
			model={this.dataService}
			setBusy={this.props.setBusy}
			onItemDoubleClicked={this.onItemDoubleClicked}
			initializeData={this.initializeData}
            {...this.props } />
	}

	@autobind
	private async initializeData(productProviderApiName: string): Promise<void> {
		const context = await this.contextService.current();
		const quoteId = this.dataService.item.id;
		const result = await context.InitializeData(productProviderApiName);

		this.toast.showToast('Data initialized!', "Data initialization for product provider succeed", 'success');

	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-providers/list/product-provider-list.controller.tsx